var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluentiaReyesmagosNoLetters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 334,
    viewBox: "0 0 301 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_14025)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.881 151.854C241.645 135.358 204.627 128.036 146.372 139.308C94.1131 149.386 47.9754 171.189 37.0656 208.131C19.1185 200.479 6.29321 190.195 6.29321 171.436C6.29321 123.922 58.1773 97.0182 118.015 85.4586C224.323 64.8899 259.926 106.315 263.881 151.854Z",
    fill: "#00E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.145 230.053C210.123 270.614 169.107 280.487 127.55 245.438C103.773 225.281 64.4229 219.81 37.0651 208.168C47.9749 171.226 94.1542 149.423 146.371 139.345C204.627 128.073 241.687 135.395 263.881 151.892C266.463 181.593 255.636 213.022 242.145 230.094V230.053Z",
    fill: "#009EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270.501 283.907C238.438 324.468 197.422 334.341 155.865 299.251C116.473 265.971 34.608 272.759 34.608 225.245C34.608 219.198 35.4408 213.521 37.0231 208.132C64.4226 219.774 103.731 225.286 127.508 245.402C169.065 280.492 210.081 270.619 242.103 230.017C255.594 212.945 266.462 181.516 263.839 151.814C308.603 184.889 293.32 254.946 270.46 283.866L270.501 283.907Z",
    fill: "#7641FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3781_14025)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6376 49.4683C98.6376 49.4683 135.311 16.4201 141.267 17.1301C147.216 17.8596 178.255 77.471 178.255 77.471C178.255 77.471 233.794 38.6639 238.93 38.7054C245.137 38.7546 266.765 90.2987 265.546 97.5572C261.74 120.433 94.7698 88.2107 98.618 49.4609L98.6376 49.4683Z",
    fill: "#E58325"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2201 97.809C73.2201 97.809 85.345 25.0891 89.3517 22.7424C96.8772 18.3305 126.825 63.3172 126.825 63.3172C126.825 63.3172 178.418 21.8727 187.604 22.2769C196.789 22.6812 228.24 87.2463 228.24 87.2463C228.24 87.2463 274.368 59.0986 278.415 63.8221C284.34 70.7297 262.778 143.706 262.778 143.706C262.778 143.706 227.161 159.543 164.944 145.132C94.1011 128.728 73.2127 97.8285 73.2127 97.8285L73.2201 97.809Z",
    fill: "#FEC318"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0493 109.68C88.2895 93.4658 98.6709 39.9114 94.6541 39.873C90.8821 39.8388 82.147 85.5408 78.7678 104.061C80.4299 105.696 82.5244 107.606 85.0493 109.68Z",
    fill: "#FDE500"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.422 63.8029C274.368 59.0988 228.248 87.2271 228.248 87.2271C228.248 87.2271 199.811 28.8617 189.125 22.8118C200.995 44.691 219.211 104.194 208.293 120.044C196.37 137.359 146.891 134.43 110.576 125.988C124.062 132.859 141.837 139.761 164.951 145.113C227.169 159.524 262.785 143.687 262.785 143.687C262.785 143.687 284.354 70.691 278.422 63.8029Z",
    fill: "#E58325"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.681 129.925C248.706 134.253 209.872 140.719 165.127 130.358C116.571 119.123 84.8992 93.4876 75.4367 84.9883C75.128 86.7401 74.8441 88.3679 74.5998 89.8328C81.8948 97.0839 111.896 124.109 165.059 136.007C210.008 146.068 247.062 139.925 265.184 135.387C265.647 133.76 266.144 131.924 266.701 129.933L266.681 129.925Z",
    fill: "#E58325"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_14025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 334,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3781_14025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205.496,
    height: 128.451,
    fill: "white",
    transform: "translate(102.662 -13.272) rotate(20.8461)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluentiaReyesmagosNoLetters);
export default __webpack_public_path__ + "static/media/influentia-reyesmagos-no-letters.903367646e0923d66f04bc1c7e0c1974.svg";
export { ForwardRef as ReactComponent };